import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const LandscapePage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Landscape Page</p>
      </Container>
    </Layout>
  );
}

export default LandscapePage
